<template>

    <div class="back-nav">

        <main-logo>
        </main-logo>

        <b-navbar v-if="breadcrumbs" class="breadcrumbs">
            <b-navbar-nav>
                <b-nav-item v-for="(segment,i) in breadcrumbs" :key="i"
                            :to="segment.to">
                    <shs-icon name="chevron-left"></shs-icon>
                    <span v-if="segment.labelKey">
                        {{ $i18n.gt(segment.labelKey) }}
                    </span>
                    <span v-else>
                        {{ segment.label }}
                    </span>
                </b-nav-item>
            </b-navbar-nav>
        </b-navbar>

    </div>

</template>

<script>

/**
 * Component for displaying breadcrumbs based on meta.crumbs data specified in the router rules.
 * See providers/Breadcrumbs.js for the service that performs dynamic substitutions in URLs and labels.
 * On mobile, only the last crumb is displayed, as a "back button".
 */

import Vue from 'vue'
import * as _ from 'lodash'

export default Vue.extend({
    name: 'BackNav',
    computed: {
        breadcrumbs() {
            if (this.$mq == 'sm') {
                if (this.$store.state.breadcrumbs.length) {
                    return [_.last(this.$store.state.breadcrumbs)]
                } else {
                    return []
                }
            } else {
                return this.$store.state.breadcrumbs
            }
        },
        hasBreadcrumbs() {
            return !!this.breadcrumbs && this.breadcrumbs.length > 0
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler: function (to, from) {
                // set body class according to whether there are breadcrumbs
                document.body.classList.toggle('has-breadcrumbs', this.hasBreadcrumbs)
            }
        }
    },
})

</script>

<style lang="scss">

@import '../../sass/base';

// HACK (?): we manipulate the header and main logo according to the
// .has-breadcrumbs class that we toggle on the body above...

.content-outer {
    padding-bottom: 1em;
}

.back-nav {
    background-color: transparent;

    .breadcrumbs {
        li {
            &:first-child a.nav-link {
                padding-left: 0;
            }
        }

        a.nav-link {
            //font-weight: bold;

            &:hover {
                color: var(--link-color) !important;
                background-color: transparent;
            }
        }
    }

    .navbar {
        padding: 0;
        //padding-top: 1em;
    }

    a.nav-link {
        color: #888;
        font-weight: 300;
        font-size: 14px;
        padding-right: 1em;

        use {
            fill: #888;
        }

        &:hover, &:focus {
            color: var(--link-color);
            outline: none;
            background-color: transparent;

            use {
                fill: var(--link-color);
            }
        }

        svg {
            @include transform(translateY(3px));
            margin-right: 0 !important;
            margin-left: 0 !important;
            width: 14px;
            height: 14px;
            @include transform(translateY(2px));
        }
    }

    @media (max-width: 991px) {
        padding-left: 60px;
        position: relative;
        a.nav-link {
            color: #888 !important;
        }
        .navbar-nav {
            flex-direction: row;
        }
    }

    @media (min-width: 992px) {

        .navbar {
            position: absolute;
            top: 72px;
        }
    }

}


</style>
